"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: payroll/direct-deposit-info.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fpayroll%2Fdirect-deposit-info.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDepositInfoCounts = exports.DirectDepositInfoTotals = exports.DirectDepositInfoOccurrences = exports.DirectDepositInfo = void 0;
const amount_1 = require("../common/amount");
const date_1 = require("../common/date");
const protobufPackage = 'com.step.payroll.proto';
function createBaseDirectDepositInfo() {
    return {
        userId: '',
        primaryAccountId: '',
        occurrences: exports.DirectDepositInfoOccurrences.fromPartial({}),
        totals: exports.DirectDepositInfoTotals.fromPartial({}),
        counts: exports.DirectDepositInfoCounts.fromPartial({}),
        futureDirectDepositDates: [],
    };
}
exports.DirectDepositInfo = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            occurrences: isSet(object.occurrences)
                ? exports.DirectDepositInfoOccurrences.fromJSON(object.occurrences)
                : exports.DirectDepositInfoOccurrences.fromPartial({}),
            totals: isSet(object.totals)
                ? exports.DirectDepositInfoTotals.fromJSON(object.totals)
                : exports.DirectDepositInfoTotals.fromPartial({}),
            counts: isSet(object.counts)
                ? exports.DirectDepositInfoCounts.fromJSON(object.counts)
                : exports.DirectDepositInfoCounts.fromPartial({}),
        };
        if (globalThis.Array.isArray(object?.futureDirectDepositDates)) {
            message.futureDirectDepositDates = object.futureDirectDepositDates.map((e) => date_1.LocalDate.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.occurrences !== undefined) {
            obj.occurrences = exports.DirectDepositInfoOccurrences.toJSON(message.occurrences);
        }
        if (message.totals !== undefined) {
            obj.totals = exports.DirectDepositInfoTotals.toJSON(message.totals);
        }
        if (message.counts !== undefined) {
            obj.counts = exports.DirectDepositInfoCounts.toJSON(message.counts);
        }
        if (message.futureDirectDepositDates?.length) {
            obj.futureDirectDepositDates = message.futureDirectDepositDates.map((e) => date_1.LocalDate.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.DirectDepositInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDirectDepositInfo();
        message.userId = object.userId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.occurrences = (object.occurrences !== undefined && object.occurrences !== null)
            ? exports.DirectDepositInfoOccurrences.fromPartial(object.occurrences)
            : exports.DirectDepositInfoOccurrences.fromPartial({});
        message.totals = (object.totals !== undefined && object.totals !== null)
            ? exports.DirectDepositInfoTotals.fromPartial(object.totals)
            : exports.DirectDepositInfoTotals.fromPartial({});
        message.counts = (object.counts !== undefined && object.counts !== null)
            ? exports.DirectDepositInfoCounts.fromPartial(object.counts)
            : exports.DirectDepositInfoCounts.fromPartial({});
        message.futureDirectDepositDates =
            object.futureDirectDepositDates?.map((e) => date_1.LocalDate.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDirectDepositInfoOccurrences() {
    return { firstMs: '0', lastMs: '0' };
}
exports.DirectDepositInfoOccurrences = {
    fromJSON(object) {
        const message = {
            firstMs: isSet(object.firstMs) ? globalThis.String(object.firstMs) : '0',
            lastMs: isSet(object.lastMs) ? globalThis.String(object.lastMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.firstMs !== '0') {
            obj.firstMs = message.firstMs;
        }
        if (message.lastMs !== '0') {
            obj.lastMs = message.lastMs;
        }
        return obj;
    },
    create(base) {
        return exports.DirectDepositInfoOccurrences.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDirectDepositInfoOccurrences();
        message.firstMs = object.firstMs ?? '0';
        message.lastMs = object.lastMs ?? '0';
        return message;
    },
};
function createBaseDirectDepositInfoTotals() {
    return {
        last30Days: amount_1.Amount.fromPartial({}),
        last35Days: undefined,
        last90Days: amount_1.Amount.fromPartial({}),
        last180Days: amount_1.Amount.fromPartial({}),
        last365Days: amount_1.Amount.fromPartial({}),
        lastMonth: amount_1.Amount.fromPartial({}),
        last3Months: amount_1.Amount.fromPartial({}),
        last6Months: amount_1.Amount.fromPartial({}),
        last12Months: amount_1.Amount.fromPartial({}),
        allTime: amount_1.Amount.fromPartial({}),
        currentYear: undefined,
    };
}
exports.DirectDepositInfoTotals = {
    fromJSON(object) {
        const message = {
            last30Days: isSet(object.last30Days)
                ? amount_1.Amount.fromJSON(object.last30Days)
                : amount_1.Amount.fromPartial({}),
            last90Days: isSet(object.last90Days)
                ? amount_1.Amount.fromJSON(object.last90Days)
                : amount_1.Amount.fromPartial({}),
            last180Days: isSet(object.last180Days)
                ? amount_1.Amount.fromJSON(object.last180Days)
                : amount_1.Amount.fromPartial({}),
            last365Days: isSet(object.last365Days)
                ? amount_1.Amount.fromJSON(object.last365Days)
                : amount_1.Amount.fromPartial({}),
            lastMonth: isSet(object.lastMonth)
                ? amount_1.Amount.fromJSON(object.lastMonth)
                : amount_1.Amount.fromPartial({}),
            last3Months: isSet(object.last3Months)
                ? amount_1.Amount.fromJSON(object.last3Months)
                : amount_1.Amount.fromPartial({}),
            last6Months: isSet(object.last6Months)
                ? amount_1.Amount.fromJSON(object.last6Months)
                : amount_1.Amount.fromPartial({}),
            last12Months: isSet(object.last12Months)
                ? amount_1.Amount.fromJSON(object.last12Months)
                : amount_1.Amount.fromPartial({}),
            allTime: isSet(object.allTime) ? amount_1.Amount.fromJSON(object.allTime) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.last35Days)) {
            message.last35Days = amount_1.Amount.fromJSON(object.last35Days);
        }
        if (isSet(object.currentYear)) {
            message.currentYear = amount_1.Amount.fromJSON(object.currentYear);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.last30Days !== undefined) {
            obj.last30Days = amount_1.Amount.toJSON(message.last30Days);
        }
        if (message.last35Days !== undefined) {
            obj.last35Days = amount_1.Amount.toJSON(message.last35Days);
        }
        if (message.last90Days !== undefined) {
            obj.last90Days = amount_1.Amount.toJSON(message.last90Days);
        }
        if (message.last180Days !== undefined) {
            obj.last180Days = amount_1.Amount.toJSON(message.last180Days);
        }
        if (message.last365Days !== undefined) {
            obj.last365Days = amount_1.Amount.toJSON(message.last365Days);
        }
        if (message.lastMonth !== undefined) {
            obj.lastMonth = amount_1.Amount.toJSON(message.lastMonth);
        }
        if (message.last3Months !== undefined) {
            obj.last3Months = amount_1.Amount.toJSON(message.last3Months);
        }
        if (message.last6Months !== undefined) {
            obj.last6Months = amount_1.Amount.toJSON(message.last6Months);
        }
        if (message.last12Months !== undefined) {
            obj.last12Months = amount_1.Amount.toJSON(message.last12Months);
        }
        if (message.allTime !== undefined) {
            obj.allTime = amount_1.Amount.toJSON(message.allTime);
        }
        if (message.currentYear !== undefined) {
            obj.currentYear = amount_1.Amount.toJSON(message.currentYear);
        }
        return obj;
    },
    create(base) {
        return exports.DirectDepositInfoTotals.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDirectDepositInfoTotals();
        message.last30Days = (object.last30Days !== undefined && object.last30Days !== null)
            ? amount_1.Amount.fromPartial(object.last30Days)
            : amount_1.Amount.fromPartial({});
        message.last35Days = (object.last35Days !== undefined && object.last35Days !== null)
            ? amount_1.Amount.fromPartial(object.last35Days)
            : undefined;
        message.last90Days = (object.last90Days !== undefined && object.last90Days !== null)
            ? amount_1.Amount.fromPartial(object.last90Days)
            : amount_1.Amount.fromPartial({});
        message.last180Days = (object.last180Days !== undefined && object.last180Days !== null)
            ? amount_1.Amount.fromPartial(object.last180Days)
            : amount_1.Amount.fromPartial({});
        message.last365Days = (object.last365Days !== undefined && object.last365Days !== null)
            ? amount_1.Amount.fromPartial(object.last365Days)
            : amount_1.Amount.fromPartial({});
        message.lastMonth = (object.lastMonth !== undefined && object.lastMonth !== null)
            ? amount_1.Amount.fromPartial(object.lastMonth)
            : amount_1.Amount.fromPartial({});
        message.last3Months = (object.last3Months !== undefined && object.last3Months !== null)
            ? amount_1.Amount.fromPartial(object.last3Months)
            : amount_1.Amount.fromPartial({});
        message.last6Months = (object.last6Months !== undefined && object.last6Months !== null)
            ? amount_1.Amount.fromPartial(object.last6Months)
            : amount_1.Amount.fromPartial({});
        message.last12Months = (object.last12Months !== undefined && object.last12Months !== null)
            ? amount_1.Amount.fromPartial(object.last12Months)
            : amount_1.Amount.fromPartial({});
        message.allTime = (object.allTime !== undefined && object.allTime !== null)
            ? amount_1.Amount.fromPartial(object.allTime)
            : amount_1.Amount.fromPartial({});
        message.currentYear = (object.currentYear !== undefined && object.currentYear !== null)
            ? amount_1.Amount.fromPartial(object.currentYear)
            : undefined;
        return message;
    },
};
function createBaseDirectDepositInfoCounts() {
    return {
        last30Days: 0,
        last35Days: 0,
        last90Days: 0,
        last180Days: 0,
        last365Days: 0,
        lastMonth: 0,
        last3Months: 0,
        last6Months: 0,
        last12Months: 0,
        allTime: 0,
        currentYear: 0,
    };
}
exports.DirectDepositInfoCounts = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.last30Days)) {
            message.last30Days = globalThis.Number(object.last30Days);
        }
        if (isSet(object.last35Days)) {
            message.last35Days = globalThis.Number(object.last35Days);
        }
        if (isSet(object.last90Days)) {
            message.last90Days = globalThis.Number(object.last90Days);
        }
        if (isSet(object.last180Days)) {
            message.last180Days = globalThis.Number(object.last180Days);
        }
        if (isSet(object.last365Days)) {
            message.last365Days = globalThis.Number(object.last365Days);
        }
        if (isSet(object.lastMonth)) {
            message.lastMonth = globalThis.Number(object.lastMonth);
        }
        if (isSet(object.last3Months)) {
            message.last3Months = globalThis.Number(object.last3Months);
        }
        if (isSet(object.last6Months)) {
            message.last6Months = globalThis.Number(object.last6Months);
        }
        if (isSet(object.last12Months)) {
            message.last12Months = globalThis.Number(object.last12Months);
        }
        if (isSet(object.allTime)) {
            message.allTime = globalThis.Number(object.allTime);
        }
        if (isSet(object.currentYear)) {
            message.currentYear = globalThis.Number(object.currentYear);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.last30Days !== undefined && message.last30Days !== 0) {
            obj.last30Days = Math.round(message.last30Days);
        }
        if (message.last35Days !== undefined && message.last35Days !== 0) {
            obj.last35Days = Math.round(message.last35Days);
        }
        if (message.last90Days !== undefined && message.last90Days !== 0) {
            obj.last90Days = Math.round(message.last90Days);
        }
        if (message.last180Days !== undefined && message.last180Days !== 0) {
            obj.last180Days = Math.round(message.last180Days);
        }
        if (message.last365Days !== undefined && message.last365Days !== 0) {
            obj.last365Days = Math.round(message.last365Days);
        }
        if (message.lastMonth !== undefined && message.lastMonth !== 0) {
            obj.lastMonth = Math.round(message.lastMonth);
        }
        if (message.last3Months !== undefined && message.last3Months !== 0) {
            obj.last3Months = Math.round(message.last3Months);
        }
        if (message.last6Months !== undefined && message.last6Months !== 0) {
            obj.last6Months = Math.round(message.last6Months);
        }
        if (message.last12Months !== undefined && message.last12Months !== 0) {
            obj.last12Months = Math.round(message.last12Months);
        }
        if (message.allTime !== undefined && message.allTime !== 0) {
            obj.allTime = Math.round(message.allTime);
        }
        if (message.currentYear !== undefined && message.currentYear !== 0) {
            obj.currentYear = Math.round(message.currentYear);
        }
        return obj;
    },
    create(base) {
        return exports.DirectDepositInfoCounts.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDirectDepositInfoCounts();
        message.last30Days = object.last30Days ?? 0;
        message.last35Days = object.last35Days ?? 0;
        message.last90Days = object.last90Days ?? 0;
        message.last180Days = object.last180Days ?? 0;
        message.last365Days = object.last365Days ?? 0;
        message.lastMonth = object.lastMonth ?? 0;
        message.last3Months = object.last3Months ?? 0;
        message.last6Months = object.last6Months ?? 0;
        message.last12Months = object.last12Months ?? 0;
        message.allTime = object.allTime ?? 0;
        message.currentYear = object.currentYear ?? 0;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=direct-deposit-info.js.map